import useAuthenticatedClients from './../../hooks/useAuthenticatedClients';
import { queryKeys } from './../../constants';
import { useQuery } from 'react-query';
import { PriorityItemDto } from '../../api';

export interface IReorderPrioritiesProps {
  employeeId: number;
  priorities: PriorityItemDto[];
}

function ProjectQueries() {
  const { getProjectsWithPriorities } = useAuthenticatedClients();
  const { CLIENT_PROJECTS_QUERY_KEY } = queryKeys;

  const FetchClientPriorities = (
    includeProxies?: boolean,
    teamId?: number,
    refetchInterval?: number,
    roleName?: string[]
  ) => {
    const result = useQuery(
      [CLIENT_PROJECTS_QUERY_KEY, null, includeProxies, teamId, null, roleName],
      async () => {
        return getProjectsWithPriorities().then(client =>
          client.getProjectPriorities(includeProxies, teamId, roleName)
        );
      },
      { refetchInterval: refetchInterval ?? false }
    );
    return result;
  };

  return {
    FetchClientPriorities,
  };
}

export default ProjectQueries;
